<template>
  <div class="animated fadeIn">
    <mensagem></mensagem>
    <b-alert v-if="mensagem" dismissible show :variant="mensagem.tipo"> {{ mensagem.mensagem }} </b-alert>
    <b-row v-if="CentroDeCustos.length > 0 && (Balanca != null || PesoManual)"
      class="d-flex justify-content-between align-items-center">
      <b-col sm="auto">
        <h2>Total no período: {{ calcularTotalGeral() }}</h2>
      </b-col>
      <b-col sm="auto">
        <div class="margin-5-bottom">
          <b-button variant="success" class="btn-square margin-5-right" @click="Finalizar">
            <h2>Finalizar</h2>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="CentroDeCustos.length <= 0">
      <b-col lg="12">
        <b-card header-tag="header" footer-tag="footer">
          <div>
            <b-jumbotron
              header="Nenhum centro de custo cadastrado, favor entrar em contato com o Administrador do sistema">
            </b-jumbotron>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="!Balanca && !PesoManual">
      <b-col lg="12">
        <b-card header-tag="header" footer-tag="footer">
          <div>
            <b-jumbotron header="Nenhuma balança localizada para este computador">
            </b-jumbotron>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <div class="grid-de-botoes" v-if="CentroDeCustos.length > 0 && (Balanca != null || PesoManual)">
      <div v-for="botao in CentroDeCustos" :key="botao.id" class="botao-container" @click="Pesar(botao)">
        <b-card class="text-center" :style="{
          backgroundColor: 'rgba(' + hexToRgb(botao.cor) + ', 0.6)',
          height: '150px'
        }">
          <h2 style="color: white;">{{ botao.descricao }}</h2>
          <b-row class="align-items-center justify-content-center">
            <b-col sm="2">
              <i class="h3 text-white fa-solid fa-weight-scale"></i>
            </b-col>
            <b-col sm="10">
              <div>
                <span class="h3 mb-0">{{ realBRLocale.format(botao.valor) }} kg</span>
              </div>
            </b-col>
            <div>
              <h6 class="text-white text-uppercase font-weight-bold">{{ botao.quantidade }} pesagens</h6>
            </div>
          </b-row>

        </b-card>
      </div>
    </div>

    <b-modal :title="`Registro de peso: ${itemPesar.descricao}`" size="xl" v-model="openModalPeso" @hidden="fecharModal"
      hide-footer :no-close-on-backdrop=true>
      <div class="d-flex flex-column align-items-center">
        <b-alert v-if="mensagemPeso" dismissible show :variant="mensagemPeso.tipo">
          <h4>{{ mensagemPeso.mensagem }}</h4>
        </b-alert>
        <input id="Peso" v-model="Peso" ref="pesoInput" class="form-control input-lg mb-3 custom-input" :disabled="!PesoManual"
          type="text" />

        <b-button variant="info" @click="PesarBalanca()" class="mb-2 custom-button" title="Pesar" :disabled="PesoManual">
          <span>Pesar</span>
        </b-button>

        <b-button variant="success" class="custom-button" @click="ConfirmarPeso()" title="Gerar">
          <span>Confirmar</span>
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Finalização do período" class="modal-danger" v-model="openModalFinalizar"
      @hidden="fecharModalFinalizar" hide-footer :no-close-on-backdrop=true>

      <div class="modalZag">
        <div class="zig-zag-wrapper">
          <div class="zig-zag">
            <pre style="background-color: rgb(240, 240, 177); font-size: 15px;">
      <strong>
        <span style="display: block; text-align: center;">
{{ arquivoImprimir.conta.nomeFantasia }}
CNPJ: {{ formatarCNPJ(arquivoImprimir.conta.cnpj) }}
</span>
========================================
Cliente: {{ arquivoImprimir.cliente.nomeCliente }}
CNPJ: {{ formatarCNPJ(arquivoImprimir.cliente.cnpj) }}
<small>{{ arquivoImprimir.usuario.padEnd(32) }}{{ dataAtual }}</small>
========================================
DESCRIÇÃO         QUANTIDADE     PESO Kg
----------------------------------------
<span v-for="centroCusto in arquivoImprimir.centroDeCusto" style="display: block; margin-bottom: -20px; margin-top: -20px;">
{{ centroCusto.descricao.padEnd(22) }}{{ centroCusto.quantidade.toString().padEnd(12) }}{{ realBRLocale.format(centroCusto.valor.toString()) }}
</span>
========================================
QTD TOTAL DE PESAGEM              {{ calcularTotalQuantidade() }}
PESO TOTAL Kg                     {{ calcularTotalPeso() }}
========================================
</strong>
  </pre>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column">
        <small>*Ao imprimir você estará finalizando o período acima</small>
        <div class="btn-group">

          <b-button variant="success" @click="confirmaFinalizar()" title="Imprimir/Finalizar" style="margin-top: 5%;">
            <span>Imprimir</span>
          </b-button>
          <b-button variant="danger" @click="fecharModalFinalizar()" title="Fechar" style="margin-top: 5%;">
            <span>Fechar</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { machineId } from 'node-machine-id';
import { isElectron } from '../../shared/isElectron';
import Mensagem from '@/base/components/Mensagem'

export default {
  name: 'configuracao',
  components: {
    Mensagem
  },
  async created() {

  },
  data() {
    return {
      dataAtual: new Date().toLocaleDateString("pt-BR", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }),
      items: [],
      loadingItens: false,
      totalDePaginas: 1,
      CentroDeCustos: [],
      mensagemPeso: null,
      mensagem: null,
      openModalPeso: false,
      ComputadorId: null,
      itemPesar: {
        descricao: ""
      },
      Balanca: null,
      Peso: 0,
      CasasDecimais: null,
      Separador: null,
      usuarioDeCadastroId: this.$store.getters.getAutenticacao.usuarioId,
      ClienteId: this.$store.getters.getAutenticacao.clienteId,
      PesoManual: this.$store.getters.getAutenticacao.pesoManual,
      realBRLocale: Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
      openModalFinalizar: false,
      arquivoImprimir:
      {
        conta: {
          nomeFantasia: null,
          cnpj: ""
        },
        cliente: {
          nomeCliente: null,
          cnpj: ""
        },
        centroDeCusto: [],
        usuario: "",
        dataFechamento: ""
      }
    }
  },
  async beforeMount() {
    this.ComputadorId = await this.getMacAddress();
    this.getCentroDeCusto()
    if (this.ComputadorId != undefined)
      this.getBalanca()
    else
      this.ComputadorId = 'Manual';
  },
  computed: {
    PesagemViewModel() {
      var vm = this
      console.log("this.ComputadorId ", this.ComputadorId)
      return {
        Id: this.balancaId || this.$uuid.v4(),
        ContaId: this.$store.getters.getAutenticacao.contaId,
        UsuarioCadastroId: this.usuarioDeCadastroId,
        ClienteId: this.ClienteId,
        CentroDeCustoId: this.itemPesar.id,
        ComputadorId: this.ComputadorId,
        Peso: this.Peso
      }
    }
  },
  methods: {
    Finalizar() {
      this.$http({ url: '/pesagem/visualiza-rol/' + this.$store.getters.getAutenticacao.contaId + "/" + this.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
        .then(async response => {
          this.arquivoImprimir = response.data
          this.openModalFinalizar = true;
        })
        .catch(err => {
          alert(err.message)
        })

    },
    async getMacAddress() {
      try {
        const macAddress = await machineId();
        return macAddress;
      } catch (error) {
        this.error = error;
      }
    },
    hexToRgb(hex) {
      // Remover o caractere "#" se estiver presente
      hex = hex.replace("#", "");

      // Converter o valor hexadecimal para RGB
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `${r}, ${g}, ${b}`;
    },
    calcularTotalGeral() {
      let totalPeso = 0;
      let totalQuantidade = 0;
      for (const centroCusto of this.CentroDeCustos) {
        totalPeso += centroCusto.valor;
        totalQuantidade += centroCusto.quantidade;
      }
      return this.realBRLocale.format(totalPeso) + ' kg em ' + totalQuantidade + ' PESAGENS';
    },
    calcularTotalQuantidade() {
      let totalQuantidade = 0;
      for (const centroCusto of this.arquivoImprimir.centroDeCusto) {
        totalQuantidade += centroCusto.quantidade;
      }
      return totalQuantidade;
    },
    calcularTotalPeso() {
      let totalPeso = 0;
      for (const centroCusto of this.arquivoImprimir.centroDeCusto) {
        totalPeso += centroCusto.valor;
      }
      return this.realBRLocale.format(totalPeso);
    },
    getBalanca() {
      var vm = this
      vm.loadingItens = true
      this.$http({ url: '/configuracao/' + vm.ComputadorId, method: 'GET' })
        .then(response => {
          vm.loadingItens = false
          if (response.data.portaCom) {
            vm.Balanca = {
              path: response.data.portaCom,
              baudRate: response.data.bitrate,
              dataBits: response.data.dataBit,
              parity: response.data.paridade,
              rtscts: response.data.rts,
              xany: response.data.xAny,
              xoff: response.data.xOff,
              xon: response.data.xOn
            }
            vm.Separador = response.data.separador
            vm.CasasDecimais = response.data.casasDecimais
          };
        })
        .catch(err => {
          alert(err.message)
        })
    },
    getCentroDeCusto() {
      var vm = this
      vm.loadingItens = true
      this.$http({ url: '/centro-de-custo/' + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
        .then(response => {
          vm.loadingItens = false
          vm.CentroDeCustos = response.data.listagem

        })
        .catch(err => {
          alert(err.message)
        })
    },
    Pesar(botao) {
      this.itemPesar = botao;
      this.openModalPeso = true
      setTimeout(() => {
        if(this.PesoManual){
          this.$refs.pesoInput.focus();
        }
      }, 200);

    },
    async PesarBalanca() {
      if (isElectron) {
        //const { SerialPort } = await import('serialport');
        let vm = this;
        vm.Peso = 0;
        vm.mensagemPeso = null;
        const port = new SerialPort(
          this.Balanca);
        port.on('open', (err) => {
          if (err) {
            return console.error('Error opening port: ', err.message);
          }
          console.log('Port opened');

          port.write(Buffer.from([0x05]), (err) => {
            if (err) {
              return console.log('Error on write: ', err.message);
            }
            console.log('Command sent');
          });

          port.on('readable', function () {
            const data = port.read();
            let numero = data.toString().match(/\d+(\.\d+)?/);
            const numerico = parseFloat(numero[0])
            let resultado = (numerico / Math.pow(10, vm.CasasDecimais)).toFixed(vm.CasasDecimais);
            vm.Peso = resultado.replace(".", vm.Separador);
            console.log("PesoResultado", vm.Peso)
          })

          setTimeout(() => {
            port.close((err) => {
              if (err) {
                console.error('Erro ao fechar a conexão:', err);
              } else {
                console.log('Conexão fechada com a balança.');
                if (vm.Peso === 0)
                  vm.mensagemPeso = { tipo: "danger", mensagem: "Nenhum peso registrado, verifique se a balança está estavel e tente novamente!" }
              }
            });
          }, 200);
        });
        port.on('error', (error) => {
          console.error('Erro na comunicação serial:', error);
          this.mensagemPeso = { tipo: "danger", mensagem: "Erro na comunicação serial: " + error }
        });
      }
    },
    ConfirmarPeso() {
      if (this.Peso === 0) {
        this.mensagemPeso = { tipo: "danger", mensagem: "O Peso deve ser diferente de 0 para confirmar" }
        return;
      }

      this.$http({ url: '/pesagem/novo', data: this.PesagemViewModel, method: 'POST' })
        .then(response => {
          if (!response.data.sucesso) {
            vm.erros = response.data.erros
            vm.$refs.botaoSalvar.unloading()
            return
          }
          this.$store.commit("set_mensagem", { tipo: "success", mensagem: "Peso do/da " + this.itemPesar.descricao + " registrado com sucesso" })
          this.$router.go()
        })
        .catch(err => {
          this.mensagemPeso = { tipo: "danger", mensagem: "Erro ao registrar o peso " + err }
        })


    },
    fecharModal() {
      this.Peso = 0;
      this.mensagemPeso = null;
    },
    fecharModalFinalizar() {
      this.$router.go()
    },
    async confirmaFinalizar() {

      this.$http({ url: '/pesagem/finalizar/' + this.$store.getters.getAutenticacao.contaId + "/" + this.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
        .then(async response => {
          const htmlContent = document.querySelector(".zig-zag").innerHTML;

          try {
            if (isElectron) {
              const { ipcRenderer } = await import('electron');
              await ipcRenderer.invoke("printContent", htmlContent);
              console.log("Impressão iniciada com sucesso!");
            }else{
              // Criar um elemento temporário para renderizar o HTML
            const tempContainer = document.createElement("div");
            tempContainer.innerHTML = htmlContent;

            // Abrir a janela de impressão para o elemento temporário
            const printWindow = window.open('', '_blank');
            printWindow.document.body.appendChild(tempContainer);

            // Esperar um curto período para garantir que o conteúdo seja renderizado
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Iniciar a impressão
            printWindow.print();
            console.log("Impressão iniciada com sucesso!");
            }
          } catch (error) {
            console.error("Erro ao iniciar a impressão:", error);
          }
        })
        .catch(err => {
          alert(err.message)
        })
    },
    formatarCNPJ(cnpj) {
      // Lógica para formatar o CNPJ com a máscara
      const cnpjFormatado = cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
      return cnpjFormatado;
    },
  },
}
</script>
<style scoped>
.grid-de-botoes {
  display: flex;
  /* Exibe os botões em uma linha */
  flex-wrap: wrap;
  /* Quebra a linha quando os botões não couberem mais */
  justify-content: flex-start;
  /* Alinha os botões à esquerda */
  margin: 0 auto;
  /* Centraliza a div na tela (opcional) */
}

.botao-container {
  flex: 0 0 33%;
  /* Define cada botão para ocupar 25% da largura da div pai (pode ajustar o valor conforme necessário) */
  padding: 5px;
  /* Adicione algum espaçamento entre os botões */
  box-sizing: border-box;
  /* Garante que o padding não aumente a largura dos botões */
  /* Adicione aqui outros estilos que você deseja aplicar aos botões */
}

button {
  padding: 10px;
  border: none;
  cursor: pointer;
  width: 100%;
}


input {
  margin-left: 10px;
}

.custom-input {
  width: 300px;
  /* Ajuste a largura conforme necessário */
  height: 60px;
  /* Ajuste a altura conforme necessário */
  font-size: 40px;
  /* Ajuste o tamanho da fonte conforme necessário */
  color: red;
  text-align: end;
}

.custom-button {
  height: 70px;
  /* Ajuste a altura conforme necessário */
  font-size: 20px;
  /* Ajuste o tamanho da fonte conforme necessário */
}

.zig-zag {
  justify-content: center;
  align-items: center;
  margin: 0;
}

.zig-zag:before {
  display: block;
  content: "";
  width: 100%;
  height: 20px;
  background: linear-gradient(45deg, rgb(240, 240, 177) 25%, transparent 25%), linear-gradient(-45deg, rgb(240, 240, 177) 25%, transparent 25%);
  background-size: 20px 20px;
  top: -18px;
  left: 0;

}

.zig-zag:after {
  display: block;
  content: "";
  width: 100%;
  height: 20px;
  background: linear-gradient(135deg, rgb(240, 240, 177) 25%, transparent 25%), linear-gradient(-135deg, rgb(240, 240, 177) 25%, transparent 25%);
  background-size: 20px 22px;
  background-position: -50px;
  margin-top: -17px;
  left: 0;

}

.modalZag {
  background-color: white;
  box-shadow: -10 0 5px rgba(0, 0, 0, 0.5);

}

.modalZag pre {
  text-align: left;
}

.zig-zag-wrapper {
  display: flex;
  justify-content: center;
}</style>
  